export const getIntentName = () => sessionStorage.getItem('intent-name') || '';
export const setIntentName = (newName) => { sessionStorage.setItem('intent-name', newName); };

export const getButtonName = () => sessionStorage.getItem('button-name') || '';
export const setButtonName = (newName) => { sessionStorage.setItem('button-name', newName); };

export const getIntentTicket = () => sessionStorage.getItem('intent-ticket') || '';
export const setIntentTicket = (newName) => { sessionStorage.setItem('intent-ticket', newName); };

export const getCurrentFlow = () => sessionStorage.getItem('current-flow') || '';
export const setCurrentFlow = (newName) => { sessionStorage.setItem('current-flow', newName); };

export const getNumber = () => sessionStorage.getItem('mobileno') || '';
export const setNumber = (newNo) => { sessionStorage.setItem('mobileno', newNo); };

export const clearSessionStorage = () => { sessionStorage.clear(); };

export const getIntentValue = () => sessionStorage.getItem('intent-value') || '';
export const setIntentValue = (newName) => { sessionStorage.setItem('intent-value', newName); };

export const getAWBValue = () => sessionStorage.getItem('awb') || '';
export const setAWBValue = (newName) => { sessionStorage.setItem('awb', newName); };

export const getIsOTPValidated = () => sessionStorage.getItem('valid') || '';
export const setIsOTPValidated = (newName) => { sessionStorage.setItem('valid', newName); };

export const clearSelectedKeys = (keys) => { keys.forEach(key => sessionStorage.removeItem(key)); };

export const getIsOtpSent = () => sessionStorage.getItem('otpSent') || false;
export const setIsOtpSent = (newValue) => { sessionStorage.setItem('otpSent', newValue); };

export const getRegisteredNo = () => sessionStorage.getItem('registeredNo') || false;
export const setRegisteredNo = (newValue) => { sessionStorage.setItem('registeredNo', newValue); };

export const getShipmentStatus = () => sessionStorage.getItem('shipmentStatus') || false;
export const setShipmentStatus = (newValue) => { sessionStorage.setItem('shipmentStatus', newValue); };

export const getAttemptCount = () => sessionStorage.getItem('attemptCount') || 0;
export const setAttemptCount = (newValue) => { sessionStorage.setItem('attemptCount', newValue); };

export const getEDD = () => sessionStorage.getItem('edd') || '';
export const setEDD = (newValue) => { sessionStorage.setItem('edd', newValue); };

export const getShipmentType = () => sessionStorage.getItem('shipmentType') || false;
export const setShipmentType = (newValue) => { sessionStorage.setItem('shipmentType', newValue); };

export const getBusinessType = () => sessionStorage.getItem('businessType') || false;
export const setBusinessType = (newValue) => { sessionStorage.setItem('businessType', newValue); };

export const getPddBreach = () => sessionStorage.getItem('pddBreach') || 'false';
export const setPddBreach = (newValue) => { sessionStorage.setItem('pddBreach', newValue); };

export const getDDT = () => sessionStorage.getItem('deliveryDate') || '';
export const setDDT = (newValue) => { sessionStorage.setItem('deliveryDate', newValue); };

export const getClientName = () => sessionStorage.getItem('clientName') || '';
export const setClientName = (newValue) => { sessionStorage.setItem('clientName', newValue); };

export const getReattemptDate = () => sessionStorage.getItem('reattemptDate') || '';
export const setReattemptDate = (newValue) => { sessionStorage.setItem('reattemptDate', newValue); };

export const getNDR = () => sessionStorage.getItem('ndrReason') || '';
export const setNDR = (newValue) => { sessionStorage.setItem('ndrReason', newValue); };

export const getNDRDate = () => sessionStorage.getItem('ndrDate') || '';
export const setNDRDate = (newValue) => { sessionStorage.setItem('ndrDate', newValue); };

export const getWHHandOver = () => sessionStorage.getItem('WHHandOver') || 'false';
export const setWHHandOver = (newValue) => { sessionStorage.setItem('WHHandOver', newValue); };

// OTP attempt counter — client-side guard (server enforces the real limit via Redis)
export const getOtpAttempts = () => parseInt(sessionStorage.getItem('otpAttempts') || '0', 10);
export const setOtpAttempts = (count) => { sessionStorage.setItem('otpAttempts', String(count)); };
export const resetOtpAttempts = () => { sessionStorage.removeItem('otpAttempts'); };

export const getLatestShipmentStatus = () => sessionStorage.getItem('latestShipmentStatus') || '';
export const setLatestShipmentStatus = (value) => { sessionStorage.setItem('latestShipmentStatus', value); };

// Session ID — UUID v4, generated once per browser session
const generateUUID = () =>
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });

export const getSessionId = () => {
    let id = sessionStorage.getItem('session-id');
    if (!id) {
        id = generateUUID();
        sessionStorage.setItem('session-id', id);
    }
    return id;
};

export const resetSessionId = () => {
    sessionStorage.removeItem('session-id');
};

// Alternate contact number retry counter
export const getAltNumRetry = () => parseInt(sessionStorage.getItem('altNumRetry') || '0', 10);
export const setAltNumRetry = (count) => { sessionStorage.setItem('altNumRetry', String(count)); };
export const resetAltNumRetry = () => { sessionStorage.removeItem('altNumRetry'); };


export const getAddressUpdateStep = () => sessionStorage.getItem('addressUpdateStep') || '';

export const setAddressUpdateStep = (newValue) => {
  sessionStorage.setItem('addressUpdateStep', newValue);
};

export const getAddressPincode = () => sessionStorage.getItem('addressPincode') || '';

export const setAddressPincode = (newValue) => {
  sessionStorage.setItem('addressPincode', newValue);
};

export const getRiderName = () => sessionStorage.getItem('riderName') || '';

export const setRiderName = (newValue) => {
  sessionStorage.setItem('riderName', newValue);
};

export const getNdrVerificationSource = () => sessionStorage.getItem('ndrVerificationSource') || '';

export const setNdrVerificationSource = (newValue) => {
  sessionStorage.setItem('ndrVerificationSource', newValue);
};

export const getNdrShipmentSnapshot = () => {
  try {
    const raw = sessionStorage.getItem('ndrShipmentSnapshot');
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

export const setNdrShipmentSnapshot = (shipment) => {
  if (shipment) {
    sessionStorage.setItem('ndrShipmentSnapshot', JSON.stringify(shipment));
  } else {
    sessionStorage.removeItem('ndrShipmentSnapshot');
  }
};

export const setNdrConcernsActive = (active) => {
  sessionStorage.setItem('ndrConcernsActive', active ? 'true' : 'false');
};

export const isNdrConcernsActive = () => sessionStorage.getItem('ndrConcernsActive') === 'true';

export const setRiderConcernsActive = (active) => {
  if (active) {
    sessionStorage.setItem('riderConcernsActive', 'true');
  } else {
    sessionStorage.removeItem('riderConcernsActive');
    sessionStorage.removeItem('riderConcernOptions');
  }
};

export const isRiderConcernsActive = () => sessionStorage.getItem('riderConcernsActive') === 'true';

// Rider sub-concern button labels are sourced from Mongo (never hardcoded).
export const setRiderConcernOptions = (labels) => {
  sessionStorage.setItem('riderConcernOptions', JSON.stringify(Array.isArray(labels) ? labels : []));
};

export const getRiderConcernOptions = () => {
  try {
    return JSON.parse(sessionStorage.getItem('riderConcernOptions') || '[]');
  } catch (error) {
    return [];
  }
};

// Survives clearSelectedKeys — tracks PNC reschedule YES/NO prompt awaiting user input
export const setPncReschedulePending = (active) => {
  if (active) {
    sessionStorage.setItem('ndr-pnc-reschedule-pending', 'true');
  } else {
    sessionStorage.removeItem('ndr-pnc-reschedule-pending');
  }
};

export const isPncReschedulePending = () => sessionStorage.getItem('ndr-pnc-reschedule-pending') === 'true';

// Survives clearSelectedKeys — Address incomplete Direct ADI awaiting post-ticket validated check
export const setAdiPostAddressPending = (active) => {
  if (active) {
    sessionStorage.setItem('ndr-adi-post-address-pending', 'true');
  } else {
    sessionStorage.removeItem('ndr-adi-post-address-pending');
  }
};

export const isAdiPostAddressPending = () => sessionStorage.getItem('ndr-adi-post-address-pending') === 'true';

// Explicit delivered-flow closing sequence flag (still-have-query → CC → additional options).
// Set only from delivered entry points — not inferred from shipment status.
export const setDeliveredClosingFlow = (active) => {
  if (active) {
    sessionStorage.setItem('deliveredClosingFlow', 'true');
  } else {
    sessionStorage.removeItem('deliveredClosingFlow');
  }
};

export const isDeliveredClosingFlow = () => sessionStorage.getItem('deliveredClosingFlow') === 'true';

export const getNprShipmentSnapshot = () => {
  try {
    const raw = sessionStorage.getItem('nprShipmentSnapshot');
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

export const setNprShipmentSnapshot = (shipment) => {
  if (shipment) {
    sessionStorage.setItem('nprShipmentSnapshot', JSON.stringify(shipment));
  } else {
    sessionStorage.removeItem('nprShipmentSnapshot');
  }
};

export const setNprConcernsActive = (active) => {
  sessionStorage.setItem('nprConcernsActive', active ? 'true' : 'false');
};

export const isNprConcernsActive = () => sessionStorage.getItem('nprConcernsActive') === 'true';

// Alternate-mobile OTP verification (separate from main AWB / registered-mobile OTP).
export const getAltMobileOtpStep = () => sessionStorage.getItem('altMobileOtpStep') || '';

export const setAltMobileOtpStep = (step) => {
  if (step) {
    sessionStorage.setItem('altMobileOtpStep', step);
  } else {
    sessionStorage.removeItem('altMobileOtpStep');
  }
};

export const getAltMobilePendingNumber = () => sessionStorage.getItem('altMobilePendingNumber') || '';

export const setAltMobilePendingNumber = (value) => {
  if (value) {
    sessionStorage.setItem('altMobilePendingNumber', value);
  } else {
    sessionStorage.removeItem('altMobilePendingNumber');
  }
};

export const clearAltMobileOtpState = () => {
  sessionStorage.removeItem('altMobileOtpStep');
  sessionStorage.removeItem('altMobilePendingNumber');
};